import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Nav from './components/Nav';
import Footer from './components/Footer';
import ImpactPage from './pages/ImpactPage';
import SolutionsPage from './pages/SolutionsPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfUsePage from './pages/TermsOfUsePage';
import DisclosurePage from './pages/DisclosurePage';
import BlogListPage from './pages/BlogListPage';
import BlogPostPage from './pages/BlogPostPage';

// Scroll to top whenever the route changes
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Nav />
      <Routes>
        <Route path="/"          element={<ImpactPage />} />
        <Route path="/impact"    element={<ImpactPage />} />
        <Route path="/solutions" element={<SolutionsPage />} />
        <Route path="/about"     element={<AboutPage />} />
        <Route path="/contact"    element={<ContactPage />} />
        <Route path="/privacy"    element={<PrivacyPolicyPage />} />
        <Route path="/terms"      element={<TermsOfUsePage />} />
        <Route path="/disclosure" element={<DisclosurePage />} />
        <Route path="/blog"       element={<BlogListPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        {/* 404 fallback */}
        <Route path="*" element={
          <div style={{
            minHeight: '60vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 16,
            fontFamily: 'var(--font-display)',
            color: 'var(--color-text-muted)',
          }}>
            <span style={{ fontSize: 72, fontWeight: 800, color: '#D0D8D0' }}>404</span>
            <p>Page not found.</p>
            <a href="/" style={{
              marginTop: 8,
              background: 'var(--color-primary)',
              color: 'white',
              padding: '12px 28px',
              borderRadius: 999,
              fontWeight: 700,
              fontSize: 14,
            }}>
              Back to Home
            </a>
          </div>
        } />
      </Routes>
      <Footer />
    </>
  );
}
